"use strict";

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */
"document"in self&&("classList"in document.createElement("_")&&(!document.createElementNS||"classList"in document.createElementNS("http://www.w3.org/2000/svg","g"))||!function(t){"use strict";if("Element"in t){var e="classList",n="prototype",i=t.Element[n],s=Object,r=String[n].trim||function(){return this.replace(/^\s+|\s+$/g,"")},o=Array[n].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1},c=function(t,e){this.name=t,this.code=DOMException[t],this.message=e},a=function(t,e){if(""===e)throw new c("SYNTAX_ERR","The token must not be empty.");if(/\s/.test(e))throw new c("INVALID_CHARACTER_ERR","The token must not contain space characters.");return o.call(t,e)},l=function(t){for(var e=r.call(t.getAttribute("class")||""),n=e?e.split(/\s+/):[],i=0,s=n.length;s>i;i++)this.push(n[i]);this._updateClassName=function(){t.setAttribute("class",this.toString())}},u=l[n]=[],h=function(){return new l(this)};if(c[n]=Error[n],u.item=function(t){return this[t]||null},u.contains=function(t){return~a(this,t+"")},u.add=function(){var t,e=arguments,n=0,i=e.length,s=!1;do t=e[n]+"",~a(this,t)||(this.push(t),s=!0);while(++n<i);s&&this._updateClassName()},u.remove=function(){var t,e,n=arguments,i=0,s=n.length,r=!1;do for(t=n[i]+"",e=a(this,t);~e;)this.splice(e,1),r=!0,e=a(this,t);while(++i<s);r&&this._updateClassName()},u.toggle=function(t,e){var n=this.contains(t),i=n?e!==!0&&"remove":e!==!1&&"add";return i&&this[i](t),e===!0||e===!1?e:!n},u.replace=function(t,e){var n=a(t+"");~n&&(this.splice(n,1,e),this._updateClassName())},u.toString=function(){return this.join(" ")},s.defineProperty){var f={get:h,enumerable:!0,configurable:!0};try{s.defineProperty(i,e,f)}catch(p){void 0!==p.number&&-2146823252!==p.number||(f.enumerable=!1,s.defineProperty(i,e,f))}}else s[n].__defineGetter__&&i.__defineGetter__(e,h)}}(self),function(){"use strict";var t=document.createElement("_");if(t.classList.add("c1","c2"),!t.classList.contains("c2")){var e=function(t){var e=DOMTokenList.prototype[t];DOMTokenList.prototype[t]=function(t){var n,i=arguments.length;for(n=0;i>n;n++)t=arguments[n],e.call(this,t)}};e("add"),e("remove")}if(t.classList.toggle("c3",!1),t.classList.contains("c3")){var n=DOMTokenList.prototype.toggle;DOMTokenList.prototype.toggle=function(t,e){return 1 in arguments&&!this.contains(t)==!e?e:n.call(this,t)}}"replace"in document.createElement("_").classList||(DOMTokenList.prototype.replace=function(t,e){var n=this.toString().split(" "),i=n.indexOf(t+"");~i&&(n=n.slice(i),this.remove.apply(this,n),this.add(e),this.add.apply(this,n.slice(1)))}),t=null}());

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function configuratorAjax() {
  // Private variables
  var patternElements = {},
      slideFunctions = {},
      closeFunctions = {},
      mismatchErrorWrapper; // Private functions

  var init, eventListeners, searchColorCodeInURL, handleSelectionClick, handleSelectionImgClick, handleFormSubmit, checkExceptionsCodes, handleColorCodeSuccess, handleMetaFields, handleColorCodeError, uploadClientSVG, getHue;

  init = function init() {
    mismatchErrorWrapper = document.getElementById("materialMixError");
    patternElements.frameWrapper = document.getElementById("frame--wrapper");
    patternElements.frameSelected = document.getElementById("frame--selected");
    patternElements.frameSelection = document.getElementById("frame--selection");
    patternElements.frameColorCodeHide = document.getElementById("frameColorCode--hide");
    patternElements.frameColorCodeError = document.getElementById("frameColorCode--error");
    patternElements.frameDesignSelected = document.getElementById("design--selected--frame");
    patternElements.frameColorCodeForm = document.getElementById("config--frameColorCode--form");
    patternElements.frameColorCodeWrapper = document.getElementById("config--frameColorCode--wrapper");
    patternElements.frameColorCodeContainer = document.getElementById("config--frameColorCode--container");
    patternElements.frameSvgAdded = document.getElementById("svg--frame--added");
    patternElements.frameSvgWrapper = document.getElementById("svg--frame--wrapper");
    patternElements.frameToggleViews = patternElements.frameSelected.getElementsByClassName("toggle-views")[0];
    patternElements.frameDesignSelectedSVG = patternElements.frameSelected.getElementsByClassName("design--selected--svg")[0];
    patternElements.frameDesignNotSelected = patternElements.frameColorCodeWrapper.getElementsByClassName("design--notSelected")[0];
    patternElements.frameActions = patternElements.frameColorCodeContainer.querySelectorAll('.material--catalog .btn');
    patternElements.templeWrapper = document.getElementById("temple--wrapper");
    patternElements.templeSelected = document.getElementById("temple--selected");
    patternElements.templeSelection = document.getElementById("temple--selection");
    patternElements.templeColorCodeHide = document.getElementById("templeColorCode--hide");
    patternElements.templeColorCodeError = document.getElementById("templeColorCode--error");
    patternElements.templeDesignSelected = document.getElementById("design--selected--temple");
    patternElements.templeColorCodeForm = document.getElementById("config--templeColorCode--form");
    patternElements.templeColorCodeWrapper = document.getElementById("config--templeColorCode--wrapper");
    patternElements.templeColorCodeContainer = document.getElementById("config--templeColorCode--container");
    patternElements.templeSvgAdded = document.getElementById("svg--temple--added");
    patternElements.templeSvgWrapper = document.getElementById("svg--temple--wrapper");
    patternElements.templeToggleViews = patternElements.templeSelected.getElementsByClassName("toggle-views")[0];
    patternElements.templeDesignSelectedSVG = patternElements.templeSelected.getElementsByClassName("design--selected--svg")[0];
    patternElements.templeDesignNotSelected = patternElements.templeColorCodeWrapper.getElementsByClassName("design--notSelected")[0];
    patternElements.templeActions = patternElements.templeColorCodeContainer.querySelectorAll('.material--catalog .btn');
  };

  eventListeners = function eventListeners() {
    patternElements.frameColorCodeForm.addEventListener('submit', handleFormSubmit);

    patternElements.templeColorCodeForm.addEventListener('submit', handleFormSubmit);

    document.getElementById("change--frame--selected").addEventListener('click', handleSelectionClick);
    document.getElementById("change--temple--selected").addEventListener('click', handleSelectionClick);
    [].slice.call(document.getElementsByClassName("frame--elements")).forEach(function (item) {
      return item.addEventListener('click', handleSelectionClick);
    });
    [].slice.call(document.getElementsByClassName("temple--elements")).forEach(function (item) {
      return item.addEventListener('click', handleSelectionClick);
    });

    patternElements.frameActions.forEach(function(action) {
      action.addEventListener('click', slideFunctions)
    });
    patternElements.templeActions.forEach(function(action) {
      action.addEventListener('click', slideFunctions)
    });

    [].slice.call(document.getElementById("config--frameActions--wrapper").getElementsByTagName("img")).forEach(function (item) {
      return item.addEventListener('click', handleSelectionImgClick);
    });
    [].slice.call(document.getElementById("config--templeActions--wrapper").getElementsByTagName("img")).forEach(function (item) {
      return item.addEventListener('click', handleSelectionImgClick);
    });
    [].slice.call(patternElements.frameWrapper.getElementsByClassName("userActionConfigurator--closeButton")).forEach(function (item) {
      return item.addEventListener('click', closeFunctions.frameSelectionToggle);
    });
    [].slice.call(patternElements.templeWrapper.getElementsByClassName("userActionConfigurator--closeButton")).forEach(function (item) {
      return item.addEventListener('click', closeFunctions.templeSelectionToggle);
    });

    var switchingImageView = function switchingImageView(patternId, index) {
      this.classList.remove("active");
      this[index ? "previousElementSibling" : "nextElementSibling"].classList.add("active");
      patternElements["".concat(patternId, "DesignSelectedSVG")].setAttribute('data-direction', this.getAttribute("data-direction"))
    };

    [].slice.call(patternElements.frameSelected.getElementsByClassName("switch-image-view")).forEach(function (item, index) {
      return item.addEventListener("click", function () {
        switchingImageView.call(this, "frame", index);
      });
    });
    [].slice.call(patternElements.templeSelected.getElementsByClassName("switch-image-view")).forEach(function (item, index) {
      return item.addEventListener("click", function () {
        switchingImageView.call(this, "temple", index);
      });
    });
    var uploadFrameInput = document.getElementById('config--frame--uploadInput'),
        uploadTempleInput = document.getElementById('config--temple--uploadInput');
    uploadFrameInput.addEventListener('change', uploadClientSVG);
    uploadTempleInput.addEventListener('change', uploadClientSVG);
    document.getElementById('config--frame--uploadBtn').addEventListener("click", function () {
      return uploadFrameInput.click();
    });
    document.getElementById('config--temple--uploadBtn').addEventListener("click", function () {
      return uploadTempleInput.click();
    }); // Lenses

    hueBox.addEventListener("mousedown", function (e) {
      getHue(e);

      document.onmousemove = function (e) {
        getHue(e);
      };
    });
    document.addEventListener("mouseup", function (e) {
      document.onmousemove = null;
    });
    document.querySelectorAll(".noHue--color").forEach(function (noHueBox) {
      var noHueBoxLight = noHueBox.dataset.color;
      noHueBox.addEventListener("click", function (e) {
        lensColor.setAttribute("stop-color", "".concat(noHueBoxLight));
      });
    });
    var selectionElements = document.querySelectorAll(".collection-products--wrapper");
    selectionElements.forEach(function (e) {
      if (e.querySelectorAll(".collectionWrapper")[0]) {
        if (e.querySelectorAll(".collectionWrapper")[0].childElementCount === 0) {
          e.style.display = "none";
        }
      }
    }); // Print

    var frameDesignSelectedWrapper = document.querySelector("#frame--wrapper .config--design");
    var templeDesignSelectedWrapper = document.querySelector("#temple--wrapper .config--design");
    var printDesignSelected = document.querySelector("#print--designSelected--wrapper");
    var printMaterialSelected = document.querySelector("#print--productInfo--wrapper");
    document.getElementById('btn--print').addEventListener("click", function () {
      var designSelected = document.querySelectorAll(".design--selected--wrapper");
      var materialSelected = document.querySelectorAll(".material--selected");
      var frameDesignSelected = document.querySelector("#frame--selected");
      var templeDesignSelected = document.querySelector("#temple--selected");
      var frameMaterialSelected = document.querySelector("#config--frameColorCode--metafields");
      var templeMaterialSelected = document.querySelector("#config--templeColorCode--metafields");
      designSelected.forEach(function (design) {
        printDesignSelected.appendChild(design);
      });
      materialSelected.forEach(function (design) {
        printMaterialSelected.appendChild(design);
      });
      window.print(); // After print or cancel, reappend elements where they belong

      setTimeout(function(){
        frameDesignSelectedWrapper.appendChild(frameDesignSelected);
        templeDesignSelectedWrapper.appendChild(templeDesignSelected);
        patternElements.frameColorCodeWrapper.appendChild(frameMaterialSelected);
        patternElements.templeColorCodeWrapper.appendChild(templeMaterialSelected);
        return false;
      }, 1000)
    });
  };

  getHue = function getHue(e) {
    var hslValueInPerc = 0;
    var clickX = e.clientX;
    var clickInPerc = (clickX - hueBox.getBoundingClientRect().left) * 100 / hueBox.clientWidth;

    if (hueBox.getBoundingClientRect().left > clickX) {
      hslValueInPerc = 0;
      clickInPerc = 0;
    } else if (hueBox.getBoundingClientRect().right < clickX) {
      hslValueInPerc = 360;
      clickInPerc = 100;
    } else {
      hslValueInPerc = clickInPerc * 360 / 100;
    }

    hueBoxCursor.style.left = "".concat(clickInPerc, "%");
    hueBoxCursor.style.background = "hsl(".concat(hslValueInPerc, ", 100%, 80%)");
    lensColor.setAttribute("stop-color", "hsl(".concat(hslValueInPerc, ", 100%, 80%)"));
  }; // Check for information in Url


  searchColorCodeInURL = function searchColorCodeInURL() {
    if (window.location.search && /code=/.test(window.location.search)) {
      var query = window.location.search.split("&"),
          testExpression = function testExpression(regexp) {
        return query.filter(function (item) {
          return regexp.test(item);
        })[0].split("=")[1];
      };

      if (Number(testExpression(/frame/))) {
        patternElements.frameColorCodeForm.elements.colorCode.value = testExpression(/code/);
        document.getElementsByClassName("frame--elements")[0].click();
        patternElements.frameColorCodeForm.elements.button.click();
      }

      if (Number(testExpression(/temple/))) {
        patternElements.templeColorCodeForm.elements.colorCode.value = testExpression(/code/);
        document.getElementsByClassName("temple--elements")[0].click();
        patternElements.templeColorCodeForm.elements.button.click();
      }

      document.getElementById('config--wrapper').scrollIntoView();
    }
  };

  uploadClientSVG = function uploadClientSVG(e) {
    var readFileContent = function readFileContent(file) {
      var reader = new FileReader();
      return new Promise(function (resolve, reject) {
        reader.readAsText(file);

        reader.onerror = function (error) {
          return reject(error);
        };

        reader.onload = function (event) {
          return resolve(event.target.result);
        };
      });
    };

    var input = e.target,
        patternId = this.dataset.pattern;

    if ('files' in input && input.files.length > 0) {
      readFileContent(input.files[0]).then(function (content) {
        var simulatedDiv = document.createElement("div");
        simulatedDiv.innerHTML = content;
        var pathToAppend = simulatedDiv.querySelectorAll("path"); // divToAppendTo = document.getElementById(`svg--${patternId}--wrapper`);

        pathToAppend.forEach(function (path) {
          patternElements["".concat(patternId, "SvgAdded")].appendChild(path);
          var pathId = path.id;

          if (pathId.includes("left")) {
            document.getElementById('design--selected--lense--left').setAttribute('href', "#".concat(pathId));
            document.getElementById('design--selected--lense--left').setAttribute('xlink:href', "#".concat(pathId));
          } else if (pathId.includes("right")) {
            document.getElementById('design--selected--lense--right').setAttribute('href', "#".concat(pathId));
            document.getElementById('design--selected--lense--right').setAttribute('xlink:href', "#".concat(pathId));
          } else {
            patternElements["".concat(patternId, "DesignSelected")].setAttribute('href', "#".concat(pathId));
            patternElements["".concat(patternId, "DesignSelected")].setAttribute('xlink:href', "#".concat(pathId));
          }
        }); // document.getElementById(`svg--${patternId}--wrapper`).appendChild(pathToAppend);
        // patternElements[`${patternId}DesignSelected`].setAttribute('href', `#${pathToAppend.id}`);

        patternElements["".concat(patternId, "Selected")].style.display = "flex";
        patternElements["".concat(patternId, "Selection")].style.display = "none";
        patternElements["".concat(patternId, "Selected")].classList["add"]("active");
        patternElements["".concat(patternId, "DesignNotSelected")].style.display = "none";
      }).catch(function (error) {
        return console.log(error);
      });
    } // console.log(e, e.target.value)


    e.target.value = "";
  };

  handleSelectionClick = function handleSelectionClick() {
    var patternId = this.parentNode.dataset.pattern,
        boolean = Number(this.parentNode.dataset.boolean),
        framesLenses = this.querySelectorAll(".design--selection--lenses");
    if (boolean) patternElements["".concat(patternId, "DesignSelected")].setAttribute('href', this.getElementsByClassName("design--selection--svg")[0].getAttribute('href'));
    if (boolean) patternElements["".concat(patternId, "DesignSelected")].setAttribute('xlink:href', this.getElementsByClassName("design--selection--svg")[0].getAttribute('href')); // console.log(this.parentNode.dataset.boolean);
    // Setting corresponding lenses to frames

    framesLenses.forEach(function (lense, i) {
      document.querySelector("#design--selected--lense--".concat(lense.getAttribute("data-side"))).setAttribute('href', lense.getAttribute('href'));
      document.querySelector("#design--selected--lense--".concat(lense.getAttribute("data-side"))).setAttribute('xlink:href', lense.getAttribute('href'));
    });
    patternElements["".concat(patternId, "SvgAdded")].innerHTML = "";
    patternElements["".concat(patternId, "Selected")].style.display = boolean ? "flex" : "none";
    patternElements["".concat(patternId, "Selection")].style.display = boolean ? "none" : "block";
    patternElements["".concat(patternId, "Selected")].classList[boolean ? "add" : "remove"]("active");
    patternElements["".concat(patternId, "DesignNotSelected")].style.display = boolean ? "none" : "flex";
    patternElements["".concat(patternId, "SvgWrapper")].classList[boolean ? "add" : "remove"]("active");
  };

  handleSelectionImgClick = function handleSelectionImgClick() {
    var patternId = this.dataset.pattern;
    closeFunctions["".concat(patternId, "SelectionToggle")]();
    patternElements["".concat(patternId, "ColorCodeForm")].elements.colorCode.value = this.dataset.colorcode;
    patternElements["".concat(patternId, "ColorCodeForm")].elements.button.click();
  };

  handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    var colorCode = e.target.elements.colorCode.value.toUpperCase(),
        patternId = e.target.elements.patternId.value,
        checkExceptionsCodesBound = checkExceptionsCodes.bind(null, colorCode, patternId),
        handleColorCodeSuccessBound = handleColorCodeSuccess.bind(null, patternId, 'italy');

    var colorCodeDuplicates = function colorCodeDuplicates() {

      var _filter = [{
        normal: '610926',
        duplicate: '610926-be-back'
      }, {
        normal: '610A85',
        duplicate: '610A85-chic-return'
      }, {
        normal: '610A87',
        duplicate: '610A87-chic-return'
      }].filter(function (item) {
        return item.normal == colorCode;
      }),
          _filter2 = _slicedToArray(_filter, 1),
          match = _filter2[0];

      if (match) {
        return match && match.duplicate;
      } else {
        return colorCode;
      }
    };
    if (!vipCustomer && colorCode.includes('-OUTLET') ) {
      colorCode = 'nop'
    } 

    colorCode = colorCodeDuplicates();
    patternElements["".concat(patternId, "ColorCodeError")].style.display = "none";
    patternElements["".concat(patternId, "ColorCodeHide")].style.display = "none";
    
    // This fetch below looks for a product and sees if it needs to be hidden via a tag

    fetch(`/products/${colorCode}.js`)
      .then(response => response.json())
      .then(productData => {
        if(productData.tags.includes('configurator-hide-temple') && patternId === 'temple')  {
          patternElements["".concat(patternId, "ColorCodeForm")].reset();
          patternElements["".concat(patternId, "ColorCodeHide")].style.display = "block";
        } else {
          // previous code when the colorCode is correct
          colorCode.length && ShopifyAPI.packlaboAjax('GET', "/products/".concat(colorCode, ".js"), '', true, handleColorCodeSuccessBound, checkExceptionsCodesBound);
          patternElements["".concat(patternId, "Selected")].style.display = "none";
          setTimeout(function () {
            patternElements["".concat(patternId, "Selected")].style.display = "flex";
          }, 1000);
        }
      })
      .catch(error => console.error('Error:', error));
  };

  checkExceptionsCodes = function checkExceptionsCodes(colorCode, patternId, error, callback) {
    var expections = function expections() {
      var _filter3 = [{
        ch: '803627',
        it: '003627'
      }, {
        ch: '803702',
        it: '003702'
      }, {
        ch: '803703',
        it: '003703'
      }, {
        ch: '816519',
        it: '016519'
      }, {
        ch: '009516TDM',
        it: 'B49000'
      }, {
        ch: 'J509319T',
        it: 'J99097A'
      }, {
        ch: 'D803627',
        it: 'D003627'
      }, {
        ch: '80D8165193627',
        it: 'D016519'
      }, {
        ch: 'DBK001T',
        it: 'D99097A'
      }, {
        ch: 'D816519',
        it: 'D016519'
      }, {
        ch: '0T001J',
        it: '99097A'
      }, {
        ch: 'J803627',
        it: "J003627"
      }, {
        ch: 'JC23000T',
        it: 'JA79025'
      }, {
        ch: 'JC23001T',
        it: 'JA79026'
      }, {
        ch: 'JC23002T',
        it: 'JA79027'
      }, {
        ch: 'JC23003T',
        it: 'JA79028'
      }].filter(function (item) {
        return item.ch == colorCode;
      }),
          _filter4 = _slicedToArray(_filter3, 1),
          match = _filter4[0];

      return match && match.it;
    };

    var startCode = function startCode() {
      var _filter5 = [{
        ch: '8',
        it: '6',
        sliceRule: 1
      }, {
        ch: 'T',
        it: 'M',
        sliceRule: 1
      }, {
        ch: 'J8',
        it: 'J6',
        sliceRule: 2
      }, {
        ch: 'JT',
        it: 'JM',
        sliceRule: 2
      }, {
        ch: 'D8',
        it: 'D6',
        sliceRule: 2
      }, {
        ch: 'DT',
        it: 'DM',
        sliceRule: 2
      }].filter(function (item) {
        return item.ch == colorCode.slice(0, item.sliceRule);
      }),
          _filter6 = _slicedToArray(_filter5, 1),
          match = _filter6[0];

      return match && "".concat(match.it).concat(colorCode.slice(match.sliceRule));
    };
    var outletReplace = function outletReplace(){
      if (vipCustomer) {
        console.log("vip");
        if (colorCode.includes('/OUTLET')) {
          return colorCode.replace('/', '-');
        } else {
          return "".concat(colorCode, "-outlet");
        }
      } 
    }
    var finishCode = function finishCode() {
      var _filter7 = [,{
        ch: 'PT',
        sliceRule: -2
      }, {
        ch: 'ST',
        sliceRule: -2
      }, {
        ch: 'T',
        sliceRule: -1
      }].filter(function (item) {
        return item.ch == colorCode.slice(colorCode.length + item.sliceRule);
      }),
          _filter8 = _slicedToArray(_filter7, 1),
          match = _filter8[0];

      return match && colorCode.slice(0, match.sliceRule);
    };

    var packLabo = function packLabo() {
      return "".concat(colorCode, "-7-17");
    };

    var newColorCode = expections() || startCode() || outletReplace() || finishCode()  || packLabo(),
        handleColorCodeErrorBound = handleColorCodeError.bind(null, patternId),
        handleColorCodeSuccessBound = handleColorCodeSuccess.bind(null, patternId, newColorCode ? "asia" : "italy");
    newColorCode ? ShopifyAPI.packlaboAjax('GET', "/products/".concat(newColorCode, ".js"), '', true, handleColorCodeSuccessBound, handleColorCodeErrorBound) : handleColorCodeError(patternId, error, callback);
    // console.log("out", newColorCode);
  };

  handleColorCodeSuccess = function handleColorCodeSuccess(patternId, language, product, callbacks) {
    var handleColorCodeErrorBound = handleColorCodeError.bind(null, patternId); //Can't use ShopifyAPI.packlaboAjax because we are expecting a html response

    $.ajax({
      type: 'GET',
      url: "/products/".concat(product.handle, "?view=metafields-").concat(patternId),
      success: function success(response) {
        return [handleMetaFields(patternId, language, response, product), callbacks.forEach(function (item) {
          return item();
        })];
      },
      error: handleColorCodeErrorBound
    });
  };

  handleMetaFields = function handleMetaFields(patternId, language, response, product) {
    patternElements["".concat(patternId, "LatestProductTags")] = product.tags;
    closeFunctions["".concat(patternId, "SelectionToggle")]();

    var appendMetaFields = function appendMetaFields() {
      var div = document.createElement("div");
      div.innerHTML = response.toString();
      div.id = "config--".concat(patternId, "ColorCode--metafields");
      div.className = "material--selected product-single";
      patternElements["".concat(patternId, "ColorCodeContainer")].style.display = "none";
      patternElements["".concat(patternId, "ColorCodeWrapper")].appendChild(div);
      patternElements["".concat(patternId, "Selected")].classList.add("filled");
      patternElements["".concat(patternId, "Selected")].classList.remove("active");
      patternElements["".concat(patternId, "SvgWrapper")].classList.add("filled");
      patternElements["".concat(patternId, "ToggleViews")].style.display = product.images.length > 2 ? "block" : "none";
    };

    var showCurrentLanguageSpecs = function showCurrentLanguageSpecs() {
      var languageTitleTabs = patternElements["".concat(patternId, "ColorCodeWrapper")].querySelector(".color-code"),
          languageInfoTabs = [].slice.call(patternElements["".concat(patternId, "ColorCodeWrapper")].querySelectorAll(".tab")),
          languageTabs = [].slice.call(patternElements["".concat(patternId, "ColorCodeWrapper")].querySelectorAll(".product--tabs"));

      var toggleLanguageSpecs = function toggleLanguageSpecs() {
        languageInfoTabs.forEach(function (item) {
          return item.classList[item.dataset.tab == language ? "add" : "remove"]("active");
        });
        languageTabs.forEach(function (item) {
          return item.classList[item.dataset.tab == language ? "add" : "remove"]("active");
        });
        languageTitleTabs.innerHTML = languageInfoTabs.filter(function (item) {
          return item.classList.contains("active");
        })[0].querySelector("[data-colorCode]").innerHTML;
      };

      if (languageTabs.length == 2) {
        toggleLanguageSpecs();
        languageTabs.forEach(function (item) {
          return item.addEventListener("click", function () {
            [language = this.dataset.tab, toggleLanguageSpecs()];
          });
        });
      }
    };

    var warnOfMismatchError = function warnOfMismatchError() {
      var testMismatch = function testMismatch(item) {
        return /^m49$/.test(item) || /^M49$/.test(item) || /^M49 Bioplastic$/.test(item);
      };

      if (document.getElementById("config--frameColorCode--metafields") && document.getElementById("config--templeColorCode--metafields")) {
        mismatchErrorWrapper.classList[patternElements.frameLatestProductTags.some(testMismatch) != patternElements.templeLatestProductTags.some(testMismatch) ? "add" : "remove"]("active");
      } else mismatchErrorWrapper.classList.remove("active");
    };

    var suggestedItem = function suggestedItem() {
      if (document.getElementById("".concat(patternId, "--productDescr")).querySelectorAll("a") !== null) {
        document.getElementById("".concat(patternId, "--productDescr")).querySelectorAll("a").forEach(function (link) {
          return link.addEventListener('click', function () {
            var patternInvertedId = [patternId === "frame" ? "temple" : "frame"],
                suggestedBoolean = 1;
            if (document.getElementById("config--".concat(patternInvertedId, "ColorCode--metafields")) !== null) {
              patternElements["".concat(patternInvertedId, "ColorCodeWrapper")].removeChild(document.getElementById("config--".concat(patternInvertedId, "ColorCode--metafields")));
            }
  
            patternElements["".concat(patternInvertedId, "ToggleViews")].style.display = "none";
            patternElements["".concat(patternInvertedId, "Selected")].classList.remove("filled");
            patternElements["".concat(patternInvertedId, "SvgWrapper")].classList.remove("filled");
            patternElements["".concat(patternInvertedId, "ColorCodeContainer")].style.display = "flex";
            patternElements["".concat(patternInvertedId, "Selected")].style.display = suggestedBoolean ? "flex" : "none";
            patternElements["".concat(patternInvertedId, "Selection")].style.display = suggestedBoolean ? "none" : "block";
            patternElements["".concat(patternInvertedId, "Selected")].classList[suggestedBoolean ? "add" : "remove"]("active");
            patternElements["".concat(patternInvertedId, "DesignNotSelected")].style.display = suggestedBoolean ? "none" : "flex";
            patternElements["".concat(patternInvertedId, "SvgWrapper")].classList[suggestedBoolean ? "add" : "remove"]("active");
            patternElements["".concat(patternInvertedId, "ColorCodeForm")].elements.colorCode.value = link.innerHTML;
            patternElements["".concat(patternInvertedId, "ColorCodeForm")].elements.button.click();

          });
        });
      }
    };

    var metaFieldsEventListeners = function metaFieldsEventListeners() {
      document.getElementById("config--".concat(patternId, "Metafields--close")).addEventListener('click', function () {
        mismatchErrorWrapper.classList.remove("active");
        patternElements["".concat(patternId, "ColorCodeForm")].elements[1].value= "";
        patternElements["".concat(patternId, "ToggleViews")].style.display = "none";
        patternElements["".concat(patternId, "Selected")].classList.remove("filled");
        patternElements["".concat(patternId, "SvgWrapper")].classList.remove("filled");
        patternElements["".concat(patternId, "ColorCodeContainer")].style.display = "flex";
        patternElements["".concat(patternId, "DesignSelected")].setAttribute('data-direction', 'front');
        patternElements["".concat(patternId, "ToggleViews")].querySelectorAll('.image-view-title').forEach(function (child) {
          child.classList.remove("active");

          if (child.getAttribute("data-direction") === "back") {
            child.classList.add("active");
          }
        });
        patternElements["".concat(patternId, "ColorCodeWrapper")].removeChild(document.getElementById("config--".concat(patternId, "ColorCode--metafields")));
      });
    };

    [appendMetaFields(), showCurrentLanguageSpecs(), warnOfMismatchError(), metaFieldsEventListeners(), suggestedItem()];
  };

  handleColorCodeError = function handleColorCodeError(patternId, error, callback) {
    patternElements["".concat(patternId, "ColorCodeForm")].reset();
    patternElements["".concat(patternId, "ColorCodeError")].style.display = "block";
    callback();
  };


  slideFunctions = function slideFunctions() {
    var patternId = this.dataset.pattern;

    $(".config--"+patternId+"Selection--wrapper").slideUp();
    $("#config--"+patternId+""+this.dataset.actions +"--wrapper").slideToggle();
  };


  closeFunctions.frameSelectionToggle = function () {
    return $(".config--frameSelection--wrapper").slideUp();
  };

  closeFunctions.templeSelectionToggle = function () {
    return $(".config--templeSelection--wrapper").slideUp();
  };

  var lensColor = document.querySelector("#lens--color"),
      hueBox = document.querySelector("#hue--box--wrapper"),
      hueBoxCursor = document.querySelector("#hue--box--cursor");
  init();
  eventListeners();
  searchColorCodeInURL();
}
